var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatFirepower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.86 294.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.59,287.46,223.3,169.91l71.56-22.55-71.59-22.48L287.46,7.27,169.91,71.56,147.36,0,124.88,71.58,7.27,7.4,71.56,125,0,147.5,71.58,170,7.4,287.59,125,223.3l22.55,71.56L170,223.27ZM110.77,184.12a51.87,51.87,0,1,1,73.35,0A51.86,51.86,0,0,1,110.77,184.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatFirepower);
export default __webpack_public_path__ + "static/media/stat-firepower.26f0c6f70e581d9e6bfae0ef76b3e6e6.svg";
export { ForwardRef as ReactComponent };